import request from '@/utils/request'


// 查询球场时间段价格列表
export function listPitchPrice(query) {
  return request({
    url: '/golf/golf-pitch-price/list',
    method: 'get',
    params: query
  })
}

// 查询球场时间段价格分页
export function pagePitchPrice(query) {
  return request({
    url: '/golf/golf-pitch-price/page',
    method: 'get',
    params: query
  })
}

// 查询球场价格按周几分组
export function groupPitchPriceByWeekDay(query) {
  return request({
    url: '/golf/golf-pitch-price/group/week-day',
    method: 'get',
    params: query
  })
}

// 查询球场时间段价格详细
export function getPitchPrice(data) {
  return request({
    url: '/golf/golf-pitch-price/detail',
    method: 'get',
    params: data
  })
}

// 新增球场时间段价格
export function addPitchPrice(data) {
  return request({
    url: '/golf/golf-pitch-price/add',
    method: 'post',
    data: data
  })
}

// 修改球场时间段价格
export function updatePitchPrice(data) {
  return request({
    url: '/golf/golf-pitch-price/edit',
    method: 'post',
    data: data
  })
}

// 删除球场时间段价格
export function delPitchPrice(data) {
  return request({
    url: '/golf/golf-pitch-price/delete',
    method: 'post',
    data: data
  })
}
